module.exports = __webpack_public_path__ + "static/media/spritesheet-simbologia-old.7f764a7c.png";